import { Divider } from '@faceup/ui-base'
import { defaultLogoSize } from '@faceup/utils'
import { type FragmentType, getFragmentData, graphql } from '../../../../../__generated__'
import { useCustomValues } from '../../../../../hooks/useCustomValues'
import InstitutionLogo from '../../../../InstitutionLogo'

const fragments = {
  PartnerInstitutionLogo_reportSource: graphql(`
    fragment PartnerInstitutionLogo_reportSource on PublicReportSource {
      id
      logoUrl
      logoSize
      institution {
        id
        config {
          id
          institutionName
        }

        partner {
          id
          name
          config {
            id
            rectangularLogoUrl
          }
        }
      }
    }
  `),
}

type PartnerInstitutionLogoProps = {
  reportSource: FragmentType<typeof fragments.PartnerInstitutionLogo_reportSource>
}

export const PartnerInstitutionLogo = ({
  reportSource: _reportSource,
}: PartnerInstitutionLogoProps) => {
  const reportSource = getFragmentData(fragments.PartnerInstitutionLogo_reportSource, _reportSource)
  const customValues = useCustomValues()
  const shownLogoSize = customValues?.logoSize ?? reportSource.logoSize ?? defaultLogoSize
  const logoUrl =
    customValues?.logoBase64 ?? (customValues?.logoBase64 === null ? null : reportSource.logoUrl)
  return (
    <div className='flex gap-4 nowrap max-h-full items-center overflow-hidden min-w-0'>
      <InstitutionLogo
        name={reportSource.institution.config?.institutionName ?? ''}
        logoUrl={logoUrl}
        logoSize={shownLogoSize}
      />
      {reportSource.institution?.partner?.config?.rectangularLogoUrl && (
        <>
          <Divider type='vertical' />
          <InstitutionLogo
            name={reportSource.institution.partner.name}
            logoUrl={reportSource.institution?.partner?.config?.rectangularLogoUrl}
            logoSize={shownLogoSize}
          />
        </>
      )}
    </div>
  )
}
